import type { Decorator } from '@storybook/react-webpack5';
import React from 'react';

const pokerDecorator: Decorator = (storyFunction) => (
  <div
    style={{
      display: 'flex',
      background: '#121212',
      padding: '20px',
      minHeight: '500px'
    }}
  >
    {storyFunction()}
  </div>
);

export default pokerDecorator;
